import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const Riseio = () => {

    //scroll at the top after page is rendered
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <div className='min-h-screen p-3 md:p-1 text-black'>
            <div
                data-aos="fade-right"
                className="btn-group btn-group-vertical lg:btn-group-horizontal ml-4 lg:ml-8 m-5 mt-10">
                <Link to="/" className="btn btn-outline w-40 font-bold border-l-2 border-0 hover:bg-accent hover:border-[#dca54c] hover:text-[#dca54c] duration-500 hover:font-bold">Home</Link>
                <a href="myresume-abdulalnuman.pdf" download="myresume-abdulalnuman.pdf" className="btn btn-outline w-40 font-bold border-l-2 border-0 hover:bg-accent duration-500  hover:border-[#dca54c] hover:text-[#dca54c] hover:font-bold">My Resume</a>
            </div>
            <div
                data-aos="fade-up" data-aos-duration="500"
                className="my-6 card lg:card-side shadow-xl rounded-2xl md:w-10/12 mx-auto backdrop-blur-sm bg-white/70">
                <figure className='lg:w-1/2'><img className="object-fill" src="https://i.ibb.co/pnVhcSd/riseio-preview.png" alt="Album" loading="lazy" /></figure>
                <div className="card-body lg:p-6 lg:w-1/2">
                    <h2 className="card-title text-4xl font-semibold">Rise.io</h2>
                    <p className='text-md'>Rise.io is a course website. It is a SPA page which makes the user experience smooth. It is a course website that provides multiple paid courses.</p>
                    <div className='flex justify-end space-x-1'>
                        <a href="https://github.com/numangit/riseio-10" target="_blank" rel="noreferrer"><button className='btn btn-sm btn-accent rounded-tr-lg rounded-bl-lg'>Source Code</button></a>
                        <a href="https://riseio.web.app/" target="_blank" rel="noreferrer"><button className='btn btn-sm btn-accent rounded-tr-lg rounded-bl-lg'>Live Demo</button></a>
                    </div>
                </div>
            </div>

            <div className='my-3 text-md  md:w-10/12 mx-auto backdrop-blur-sm bg-white/70 shadow-xl rounded-2xl p-4'>
                <h2 className="card-title text-2xl font-semibold my-2">Technologies & Tools :</h2>
                <div className='space-x-2 space-y-2'>
                    <div className="badge badge-ghost">React JS</div>
                    <div className="badge badge-ghost">Node JS</div>
                    <div className="badge badge-ghost">Express</div>
                    <div className="badge badge-ghost">MongoDB</div>
                    <div className="badge badge-ghost">React Router Dom</div>
                    <div className="badge badge-ghost">Firebase</div>
                    <div className="badge badge-ghost">React icons</div>
                    <div className="badge badge-ghost">Lottie Files</div>
                    <div className="badge badge-ghost">React to pdf</div>
                </div>
                <h2 className="card-title text-2xl font-semibold my-2">Key Features :</h2>
                <p>
                    ● Single page application functionality implemented to make the user experience
                    smooth with the help of React Router Dom.
                </p>
                <p>
                    ● Firebase Authentication implemented to allow users to sign in using email and
                    google accounts.
                </p>
                <p>
                    ● Download to pdf functionality has been included for the users to download the course summary with the help of React to PDF npm package.
                </p>
            </div>
        </div>
    );
};

export default Riseio;